window.PDGIFT = window.PDGIFT || {};

(function() {
  const DECLINED_KEY = 'pd_gift_declined';

  async function refreshCartSections() {
    const sections = [
      'cart-drawer',
      'cart-icon-bubble',
      'header',
      'main-cart-items'
    ];

    const url = `${window.location.pathname}?sections=${sections.join(',')}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (data['cart-drawer']) {
        const drawer = document.querySelector('[data-section-type="cart-drawer"]');
        if (drawer) {
          const tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          const newDrawer = tmp.querySelector('[data-section-type="cart-drawer"]');
          if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
        }
      }

      if (data['cart-icon-bubble']) {
        const bubble = document.querySelector('.cart-count-bubble, [data-cart-count]');
        if (bubble) {
          const tmp = document.createElement('div');
          tmp.innerHTML = data['cart-icon-bubble'];
          const newBubble = tmp.querySelector('.cart-count-bubble, [data-cart-count]');
          if (newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
      }

      if (data['header']) {
        const header = document.querySelector('header');
        if (header) {
          const tmp = document.createElement('div');
          tmp.innerHTML = data['header'];
          const newHeader = tmp.querySelector('header');
          if (newHeader) header.innerHTML = newHeader.innerHTML;
        }
      }

      if (data['main-cart-items']) {
        const main = document.querySelector('#main-cart-items');
        if (main) {
          const tmp = document.createElement('div');
          tmp.innerHTML = data['main-cart-items'];
          const newMain = tmp.querySelector('#main-cart-items');
          if (newMain) main.innerHTML = newMain.innerHTML;
        }
      }

    } catch (err) {
      console.error("refreshCartSections error:", err);
    }
  }

  window.PDGIFT.refreshCartSections = refreshCartSections;

  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.querySelector('.pd-gift-selector');
    if (!popup) return;
    
    // RESET declined flag on every page load
    sessionStorage.removeItem(DECLINED_KEY);
    
    // --- LIMIT FIX (robust, correct dataset keys) ---
    const limitHUF = popup.dataset.limit ? parseInt(popup.dataset.limit) : 7000;
    const limitEUR = popup.dataset.limit_eur ? parseInt(popup.dataset.limit_eur) : 20;

    const currency = Shopify.currency.active.toUpperCase();
    const limitInCents = currency === 'HUF'
      ? limitHUF * 100
      : limitEUR * 100;

    const giftButtons = popup.querySelectorAll('.pd-gift-selector-add');
    const giftVariantIds = [...giftButtons].map(btn => parseInt(btn.dataset.variant));

    let manuallyDeclined = false;

    async function fetchCart() {
      const res = await fetch('/cart.js');
      return res.json();
    }

    async function checkCart() {
      const cart = await fetchCart();
      const cartTotal = cart.total_price;
      const giftInCart = cart.items.find(i => giftVariantIds.includes(i.variant_id));

      if (cartTotal >= limitInCents) {
        document.dispatchEvent(new CustomEvent('pd:gift-limit-reached'));
      }

      if (cartTotal < limitInCents && giftInCart) {
        await fetch('/cart/change.js', {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({ id: giftInCart.key, quantity: 0 })
        });

        sessionStorage.removeItem(DECLINED_KEY);
        manuallyDeclined = false;

        await refreshCartSections();
        return;
      }

      if (
        cartTotal >= limitInCents &&
        !giftInCart &&
        !manuallyDeclined
      ) {
        popup.style.display = "flex";
      } else {
        popup.style.display = "none";
      }
    }

    function closeGift() {
      popup.style.display = "none";
      sessionStorage.setItem(DECLINED_KEY, 'true');
      manuallyDeclined = true;

      document.dispatchEvent(new CustomEvent('pd:gift-closed'));
    }

    popup.querySelector('.pd-gift-selector-close').onclick = closeGift;
    popup.querySelector('.pd-gift-selector-decline').onclick = closeGift;

    giftButtons.forEach(btn => {
      btn.addEventListener("click", async () => {
        const variantId = btn.dataset.variant;

        await fetch("/cart/add.js", {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: { "_gift": "true" }
          })
        });

        popup.style.display = "none";

        await refreshCartSections();
        document.dispatchEvent(new CustomEvent('pd:gift-closed'));
      });
    });

    setTimeout(checkCart, 400);
    setInterval(checkCart, 2500);

    document.addEventListener("click", function(e) {
      const qtyBtn = e.target.closest('[name="plus"], [name="minus"], .quantity__button');
      if (qtyBtn) {
        setTimeout(checkCart, 400);
      }
    });

    document.addEventListener("change", function(e) {
      const qtyInput = e.target.closest('input[name="quantity"], .quantity__input');
      if (qtyInput) {
        setTimeout(checkCart, 400);
      }
    });

    document.body.addEventListener("click", async function(e) {
      const checkoutTrigger = e.target.closest("button[name='checkout'], .cart__checkout, #checkout, a[href*='/checkout']");
      if (!checkoutTrigger) return;

      e.preventDefault();
      e.stopPropagation();

      const cart = await fetchCart();
      const cartTotal = cart.total_price;
      const giftInCart = cart.items.find(i => giftVariantIds.includes(i.variant_id));

      if (cartTotal < limitInCents && giftInCart) {
        await fetch('/cart/change.js', {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({ id: giftInCart.key, quantity: 0 })
        });

        await refreshCartSections();

        alert('Your free gift was removed because your cart total is below the required minimum.');

        return;
      }

      const href = checkoutTrigger.getAttribute('href');
      if (href) {
        window.location.href = href;
      } else {
        const form = checkoutTrigger.closest('form');
        if (form) form.submit();
      }
    }, true);
  });

})();